module.exports = __webpack_public_path__ + "static/media/portal-exit.707c358a.svg";